import { toast } from "react-toastify";
import { axios } from "../../../utils/axios";
import { toastOptions } from "../../../config/toast";

export const obtenerPersona = async (form, setPersona) => {
  try {
    const response = await axios().get(`permissions/buscarPersona/${form.documento}`);
    const { data, error } = response.data;

    if (data) {
      setPersona(data);
    }

    if (error && !data) {
      toast.error(error,toastOptions);
    }
  } catch (error) {
    toast.error("Error al buscar la persona");
  }
};
